<template>
    <div v-if="verifyModule">
        <Paper class="pb-4" v-if="verifiedUniversities.length === 0">
            <div class="d-flex flex-column">
                <div
                    class="overlay p-2 pt-4 d-flex flex-column align-items-center justify-content-center white"
                >
                    <template v-if="!shouldBeShowingResend">
                        <h4 class="text-center contrast-color">
                            {{
                                $t(
                                    'components.miscellaneous.verifyModule.title'
                                )
                            }}
                        </h4>
                        <h6 class="text-center contrast-color p-3">
                            {{
                                $t(
                                    'components.miscellaneous.verifyModule.description'
                                )
                            }}
                        </h6>
                    </template>
                    <template v-else>
                        <h4 class="text-center contrast-color">
                            {{
                                $t(
                                    'components.miscellaneous.verifyModule.verificationPending'
                                )
                            }}
                        </h4>
                        <h6
                            class="text-center contrast-color p-3 deal-with-long-words"
                            style="max-width: var(--grid-third)"
                            v-html="
                                $t(
                                    'components.miscellaneous.verifyModule.weHaveSentAnEmail',
                                    { studentEmail: pendingUni.studentEmail }
                                )
                            "
                        />
                    </template>
                </div>
                <div class="overlay-path" />
                <div
                    class="p-2 flex-grow d-flex flex-column align-items-center justify-content-center"
                >
                    <template v-if="!shouldBeShowingResend">
                        <BaseButton
                            class="logInBtn bold"
                            variant="primary"
                            @click="handleVerifyClick"
                        >
                            {{
                                $t(
                                    'components.miscellaneous.verifyModule.verifyMe'
                                )
                            }}
                        </BaseButton>
                    </template>
                    <template v-else>
                        <BaseButton
                            class="loginBtn bold clickable darken-on-hover"
                            variant="primary"
                            :disabled="isLoading"
                            @click="handleResendClick"
                        >
                            <div
                                class="d-flex align-items-center justify-content-center"
                            >
                                <Spinner
                                    v-if="isLoading"
                                    size="sm"
                                    class="mr-2"
                                />
                                {{
                                    $t(
                                        'components.miscellaneous.verifyModule.resendVerifyEmail'
                                    )
                                }}
                            </div>
                        </BaseButton>
                        <BaseButton
                            class="loginBtn bold mt-3 error-color clickable darken-on-hover"
                            style="border-color: var(--error)"
                            @click="handleCancelClick"
                        >
                            {{
                                $t(
                                    'components.miscellaneous.verifyModule.cancelVerification'
                                )
                            }}
                        </BaseButton>
                    </template>
                </div>
            </div>
        </Paper>
    </div>
</template>

<script>
import DialogService from '~/services/DialogService';
import { getSubDomain, emailVerificationURL } from '~/utils/urlUtils';
import { VERIFY_MODULE } from '~/router';

export default {
    name: 'VerifyModule',
    data() {
        return {
            forceUpdate: false,
            isLoading: false,
            verifyModule: VERIFY_MODULE,
        };
    },
    methods: {
        handleVerifyClick() {
            DialogService.openUniVerifyDialog();
        },
        handleResendClick() {
            this.isLoading = true;
            this.$interfaces.university.connection.confirm
                .post({
                    body: {
                        id: this.pendingUni.id,
                        returnUrl: emailVerificationURL(),
                    },
                })
                .then(res => {
                    this.$interfaces.messageModule.addNewMessage({
                        title: this.$t(
                            'components.miscellaneous.verifyModule.emailSent'
                        ),
                        message: this.$t(
                            'components.miscellaneous.verifyModule.emailSentMessage'
                        ),
                    });
                })
                .catch(err => {
                    this.$interfaces.messageModule.addNewMessage({
                        state: 'ERROR',
                        title: this.$t(
                            'components.miscellaneous.verifyModule.resendErrorTitle'
                        ),
                        message: this.$t(
                            'components.miscellaneous.verifyModule.resendErrorMessage'
                        ),
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        handleCancelClick() {
            this.$interfaces.university.connection
                .id(this.pendingUni.id)
                .delete({
                    body: {},
                })
                .then(res => {
                    this.forceUniConnectionUpdate();
                    this.$interfaces.messageModule.addNewMessage({
                        title: this.$t(
                            'components.miscellaneous.verifyModule.verificationCancelledTitle'
                        ),
                        message: this.$t(
                            'components.miscellaneous.verifyModule.verificationCancelledMessage'
                        ),
                    });
                })
                .catch(res => {
                    this.forceUniConnectionUpdate();
                    this.$interfaces.messageModule.addNewMessage({
                        state: 'ERROR',
                        title: this.$t(
                            'components.miscellaneous.verifyModule.cancelErrorTitle'
                        ),
                        message: this.$t(
                            'components.miscellaneous.verifyModule.cancelErrorMessage'
                        ),
                    });
                });
        },
        forceUniConnectionUpdate() {
            this.forceUpdate = true;
        },
    },
    computed: {
        universities() {
            let shouldUpdate = this.forceUpdate === true;
            const uni = this.$interfaces.university.connection.get({
                reactive: true,
                forceUpdate: shouldUpdate,
            });
            this.forceUpdate = false;
            return uni;
        },
        shouldBeShowingResend() {
            return this.pendingUni !== undefined;
        },

        pendingUni() {
            if (!this.universities && !this.universities.loading) {
                return undefined;
            }
            return this.universities.data.find(it => it.isVerified === false);
        },

        verifiedUniversities() {
            return ((this.universities || {}).data || []).filter(
                e => e.isVerified === true
            );
        },
    },
};
</script>

<style scoped>
.deal-with-long-words {
    overflow: hidden;
    overflow-wrap: break-word;
}
.logInBtn {
    font-size: 16 px;
    width: 60%;
}
.color-white {
    color: white !important;
}

.overlay {
    border-radius: var(--border-radius) var(--border-radius) 0 0;
    background-color: var(--primary);
}
.overlay-card {
    width: 100%;
    height: 30%;
}
.overlay-path {
    position: relative;
    transform: translateY(-0.2px);
    left: 0;
    right: 0;
    width: 100%;
    height: 40px;
    -webkit-clip-path: polygon(100% 0, 0 0, 0 36%);
    clip-path: polygon(100% 0, 0 0, 0 90%);
    background-color: var(--primary);
}
.overlay-path-top {
    height: 40px;
    -webkit-clip-path: polygon(100% 0, 0 100%, 100% 100%);
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
}
</style>
